import { collection } from 'firebase/firestore';
import { app, auth } from './client';
import { database, db, functions, storage } from './services';

const shipmentCollection = collection(db, 'shipments');
const waypointCollection = collection(db, 'waypoints');

export { app, auth, database, db, functions, storage, shipmentCollection, waypointCollection };
